import { displayDollar } from "utilities/tableUtility";
import K from "utilities/constants";
import { numberSorter, stringSorter } from "utilities/sorting";

export const TableColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    align: "center",
    width: 80,
    sorter: numberSorter("id"),
  },
  {
    title: "Candidate Name",
    dataIndex: ["candidateJobEntry", "candidate", "fullName"],
    key: "candidateName",
    align: "center",
    width: 150,
    ellipsis: true,
    defaultSortOrder: "ascend",
    sorter: stringSorter("candidateJobEntry.candidate.fullName"),
    render: (text) => text ?? K.NullPlaceholder,
  },
  {
    title: "Candidate Type",
    dataIndex: ["candidateJobEntry", "candidateType"],
    key: "candidateType",
    align: "center",
    width: 130,
    render: (text) => K.CandidateType[text] ?? K.NullPlaceholder,
  },
  {
    title: "Billing Type",
    dataIndex: "billingType",
    key: "billingType",
    align: "center",
    width: 150,
    ellipsis: true,
  },
  {
    title: "Job Title",
    dataIndex: ["candidateJobEntry", "job", "title"],
    key: "jobTitle",
    align: "center",
    ellipsis: true,
    render: (text) => text ?? K.NullPlaceholder,
  },
  {
    title: "Billed Amount",
    dataIndex: "recruiterAmount",
    key: "recruiterAmount",
    align: "center",
    width: 120,
    render: (text) => displayDollar(text),
  },
  {
    title: "Commission Earned",
    dataIndex: "recruiterCommission",
    key: "recruiterCommission",
    align: "center",
    width: 150,
    render: (text) => displayDollar(text),
  },
];
